import axios from "axios";

// MCP サーバーの /send-feedback エンドポイントに直接 POST する
// 本番環境では REACT_APP_MCP_BASE_URL を設定すること
// 開発環境では /mcp-api プロキシ経由（setupProxy.js に設定が必要）
const MCP_BASE_URL =
  process.env.REACT_APP_MCP_BASE_URL || "https://www.mycompany-mcp.com";

export async function sendFeedback(subject, body, senderEmail, senderName) {
  const res = await axios.post(`${MCP_BASE_URL}/send-feedback`, {
    subject,
    body,
    senderEmail,
    senderName,
  });
  return res.data;
}
